module.exports = angular.module('cartographer.common.promise', [])

module.exports.factory 'crtPromise', $DI ($q) ->
  create = (value) ->
    $q.when(value)

  reject = (value) ->
    deferred = $q.defer()
    deferred.reject(value)
    deferred.promise

  return {
    create
    reject
  }
